<template>
  <div class="course">
    <div class="course__body">
      <cdr-text
        tag="span"
        class="course__title--subheading"
      >
        {{ courseType }}
      </cdr-text>
      <cdr-text
        tag="h2"
        class="course__title--heading-container"
      >
        <cdr-link
          v-bind="link.attrs"
          modifier="standalone"
          class="course__title--heading"
          v-on="link.on"
        >
          {{ name }}
        </cdr-link>
      </cdr-text>
      <div
        v-if="courseId"
        :data-bv-product-id="courseId"
        class="course__rating"
        data-bv-show="inline_rating"
      />
    </div>
    <div class="course__footer">
      <cdr-text
        v-if="time || duration"
        tag="div"
        data-ui="course-times"
        class="course__times"
      >
        <cdr-text
          v-if="time"
          class="course__times--time-container"
          data-ui="time"
        >
          <span
            v-if="day"
            class="course__times"
            data-ui="day"
            v-html="day"
          />
          <span
            v-if="hour"
            class="course__times"
            data-ui="hour"
            v-html="hour"
          />
        </cdr-text>

        <span
          v-else-if="duration"
          data-ui="duration"
          class="course__times--overflow"
          v-html="duration"
        />
      </cdr-text>
      <cdr-text
        data-ui="course-price"
        class="course__price"
      >
        <span v-html="price" />
      </cdr-text>
    </div>
  </div>
</template>

<script>
import { CdrLink, CdrText } from '@rei/cedar';

export default {
  name: 'CourseCardComponent',
  components: {
    CdrLink,
    CdrText,
  },
  props: {
    courseId: {
      type: [Number, String],
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    courseType: {
      type: String,
      required: true,
    },
    duration: {
      type: String,
      required: false,
      default: null,
    },
    time: {
      type: String,
      required: false,
      default: null,
    },
    price: {
      type: String,
      required: true,
    },
    link: {
      type: Object,
      required: true,
    },
  },
  computed: {
    day() {
      const { time } = this;
      return time?.split(',')?.[0] || null;
    },
    hour() {
      const { time } = this;
      return time?.split(',')?.[1]?.trim() || null;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/style/components/search/course-card-component.scss';
</style>
